<div class="tw-cursor-pointer">
    <a
        [title]="btnConfig[mobileType].label | translate"
        [href]="btnConfig[mobileType].link"
        target="_blank"
        [attr.aria-label]="btnConfig[mobileType].label | translate"
        [linkDataTest]="mobileType + 'link'"
    >
        <app-icon [attr.aria-hidden]="true" [name]="btnConfig[mobileType].icon" class="tw-w-[8.875rem] tw-h-10" type="colors" />
        <span class="tw-sr-only">{{ btnConfig[mobileType].label | translate }}</span>
    </a>
</div>
